// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"backup"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M1 14.5C1 17.5376 3.46243 20 6.5 20H17.5C20.5376 20 23 17.5376 23 14.5C23 11.7994 21.0536 9.55346 18.4872 9.08835C18.2748 5.69029 15.4516 3 12 3C8.54842 3 5.72518 5.69029 5.51282 9.08835C2.94636 9.55346 1 11.7994 1 14.5Z","fill-rule":"evenodd","clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M1 14.5C1 17.5376 3.46243 20 6.5 20H17.5C20.5376 20 23 17.5376 23 14.5C23 11.7994 21.0536 9.55346 18.4872 9.08835C18.2748 5.69029 15.4516 3 12 3C8.54842 3 5.72518 5.69029 5.51282 9.08835C2.94636 9.55346 1 11.7994 1 14.5Z","fill-rule":"evenodd","stroke-linecap":"square","stroke-width":2,"clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M15 11.5L12 8.5L9 11.5M12 16V13M12 13V9V12V13Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-backup')
export default class BackupIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'backup',
    }
  }
}
